import React from "react";
import {
  createProductUnit,
  updateProductUnit,
} from "../../../network/network";
import LocalizedNameFormModal from "../../../components/LocalizedNameFormModal";

const UnitFormModal = (props) => {
  return (
    <LocalizedNameFormModal
      {...props}
      createRequest={createProductUnit}
      updateRequest={updateProductUnit}
      addTitleKey="unit_add"
      editTitleKey="unit_edit"
      addSubmitKey="unit_add"
      nameRequiredKey="unit_name_required"
      addedTitleKey="unit_added"
      addedDescriptionKey="unit_added_successfully"
      updatedTitleKey="unit_updated"
      updatedDescriptionKey="unit_updated_successfully"
    />
  );
};

export default UnitFormModal;
